import {useQuery} from '@apollo/client';
import * as React from 'react';

import {Challenge, metaDoDesafio, statusDoDesafio, tipoDoDesafio, tituloDoDesafio} from '../challenges';
import {QUERY_STUDENT_CHALLENGES} from '../studentQueries';
import {StudentTheme} from '../studentTheme';

interface Data {
  challenges?: Challenge[] | null;
}

const COR: Record<string, keyof StudentTheme> = {ativo: 'primary', espera: 'secondary', encerrado: 'neutral'};

export const ChallengesScreen: React.FC<{theme: StudentTheme}> = ({theme}) => {
  const {data, loading, error, refetch} = useQuery<Data>(QUERY_STUDENT_CHALLENGES, {variables: {page: 1}});

  const desafios = data?.challenges ?? [];

  if (loading && desafios.length === 0) return <p className="student-screen__estado">Carregando…</p>;

  if (error && desafios.length === 0) {
    return (
      <div className="student-screen__estado">
        <p>Não foi possível carregar os desafios.</p>
        <button type="button" className="student-app__retry" onClick={() => refetch()}>
          Tentar de novo
        </button>
      </div>
    );
  }

  if (desafios.length === 0) return <p className="student-screen__estado">Nenhum desafio por aqui ainda.</p>;

  return (
    <div className="records">
      {desafios.map((desafio) => {
        const status = statusDoDesafio(desafio.status);
        const meta = metaDoDesafio(desafio);
        const tipo = tipoDoDesafio(desafio.challengeType);

        return (
          <article key={desafio.id} className="record-card" style={{backgroundColor: theme.body, borderColor: theme.border}}>
            <div className="record-card__info">
              <h2 className="record-card__nome">{tituloDoDesafio(desafio)}</h2>
              <span className="record-card__categoria" style={{color: theme.neutral}}>
                {[tipo, desafio.challenger?.name].filter(Boolean).join(' · ')}
              </span>
              {status.label && (
                <span className="aula-card__status" style={{color: theme[COR[status.tom]] as string}}>
                  {status.label}
                </span>
              )}
            </div>

            {meta && (
              <div className="record-card__marca">
                <strong style={{color: theme.primary}}>{meta}</strong>
                {desafio.result && <span style={{color: theme.neutral}}>{desafio.result}</span>}
              </div>
            )}
          </article>
        );
      })}
    </div>
  );
};
